import './gdprRequest.tpl.html';
import './selectOperation/selectOperation.js';
import './uploadView/uploadView.js';

angular
  .module('gdprRequest', [
    'ui.router',
    'ngAnimate',
    'gdprRequest.selectOperation',
    'gdprRequest.uploadView',
    'sbsf.constants',
    'services.gdprrequestdata',
    'services.error',
    'services.view',
    'shared.confirmModal'
  ])
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      // These params are shared between multiple states
      var gdprRequestParams = {
        // This will be set if we've already entered the flow
        gdprRequestData: {
          value: null,
          squash: true
        },
        // This will be set if we're coming in from a link in an email
        page: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from a link in an email
        batchId: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log
        bulkRestoreType: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log
        batch: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log for a backup
        objectType: {
          value: null,
          squash: true
        }
      };

      // This defines the main abstract gdpr request view that is shared across all subviews.
      $stateProvider
        .state(VIEW_STATES.GDPR_REQUEST, {
          abstract: true,
          views: {
            content: {
              templateUrl: 'gdprRequest/gdprRequest.tpl.html',
              controller: 'GdprRequestCtrl'
            }
          },
          resolve: {
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ]
          }
        })
        // The views that are rendered in the CSV upload view.
        .state(VIEW_STATES.GDPR_REQUEST_UPLOAD_CSV, {
          url: '/gdprRequest/uploadView',
          params: gdprRequestParams,
          views: {
            wizardContent: {
              templateUrl: 'gdprRequest/uploadView/uploadView.tpl.html',
              controller: 'GdprRequestUploadViewCtrl'
            }
          }
        })
        // The views that are rendered in the choosing gdpr operation.
        .state(VIEW_STATES.GDPR_REQUEST_SELECT_OPERATION, {
          url: '/gdprRequest/selectOperation',
          params: gdprRequestParams,
          views: {
            wizardContent: {
              templateUrl: 'gdprRequest/selectOperation/selectOperation.tpl.html',
              controller: 'GdprSelectOperationViewCtrl'
            }
          }
        });
    }
  ])
  /**
   * Controller for the bulk export view.
   */
  .controller('GdprRequestCtrl', [
    '$q',
    '$scope',
    '$state',
    '$rootScope',
    'WizardService',
    'GdprRequestDataFactory',
    'BulkRestoreService',
    'BulkRestoreType',
    'ErrorService',
    'progressFactory',
    'httpBatch',
    'viewUtils',
    'orgInfo',
    'VIEW_STATES',
    'BULK_RESTORE_TYPES',
    'BULK_RESTORE_DEST_TYPES',
    'ALERT_EVENTS',
    function (
      $q,
      $scope,
      $state,
      $rootScope,
      WizardService,
      GdprRequestDataFactory,
      BulkRestoreService,
      BulkRestoreType,
      ErrorService,
      progressFactory,
      httpBatch,
      viewUtils,
      orgInfo,
      VIEW_STATES,
      BULK_RESTORE_TYPES,
      BULK_RESTORE_DEST_TYPES,
      ALERT_EVENTS
    ) {
      $scope.gdprRequestData = initGdprRequestData();

      watchForDestroy();
      goToInitialState();

      $rootScope.showLoadingMask = false;

      /**
       * Initializes the gdpr request data if it was not passed in.
       *
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initGdprRequestData() {
        let gdprRequestData = $state.params.gdprRequestData;

        if (!gdprRequestData) {
          // Create the default data
          gdprRequestData = GdprRequestDataFactory.generate(orgInfo);
        }

        return gdprRequestData;
      }

      /**
       * Watches for the scope to be destroyed in order to do some clean-up.
       */
      function watchForDestroy() {
        $scope.$on('$destroy', function () {
          viewUtils.resetKey('export');
          $rootScope.$emit(ALERT_EVENTS.CLOSE.eventName);
        });
      }

      /**
       * Determines the initial state of the wizard from the data source.
       */
      function goToInitialState() {
        const state = VIEW_STATES.GDPR_REQUEST_UPLOAD_CSV;

        initWizard(state);
        $state.go(state, { gdprRequestData: $scope.gdprRequestData });
      }

      /**
       * Sets up the wizard service to track the flow through this wizard.
       *
       * @param {string} [initialState] - The start in which to start the wizard.
       */
      function initWizard(initialState) {
        // Reset the WizardService so we start fresh each time
        WizardService.reset();

        const stepKeys = ['UPLOAD_CSV', 'SELECT_OPERATION'];

        // Initialize the wizard
        WizardService.setStatePrefix(VIEW_STATES.GDPR_REQUEST + '.');
        WizardService.setNextState(getNextState);
        WizardService.setInitialState(initialState);
        WizardService.setStepKeys(stepKeys);
        WizardService.setCancelConfirmTextKey('CONFIRM_GDPR_REQUEST_EXIT');
      }

      /**
       * Determines the state that comes after the current state, based on the current settings.
       *
       * @returns {string} the name of the state corresponding to the next page.
       */
      function getNextState() {
        const currentState = WizardService.getCurrentState();
        let nextState;

        switch (currentState) {
          case VIEW_STATES.GDPR_REQUEST_UPLOAD_CSV:
            nextState = VIEW_STATES.GDPR_REQUEST_SELECT_OPERATION;
            break;
          default:
            break;
        }

        return nextState;
      }
    }
  ]);
